<div class="modal fade" id="kt_modal_booking_agent_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Booking Agent' : 'Add Booking Agent' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="bookingAgentForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Enter booking agent name"
                [class.is-invalid]="name?.invalid && name?.touched"
              />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Booking agent name is required</div>
                <div *ngIf="name?.errors?.['minlength']">Booking agent name must be at least 2 characters</div>
              </div>
            </div>

            <!-- Email -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Email</label>
              <input
                type="email"
                class="form-control form-control-solid"
                formControlName="email"
                placeholder="Enter email address"
                [class.is-invalid]="email?.invalid && email?.touched"
              />
              <div *ngIf="email?.invalid && email?.touched" class="invalid-feedback">
                <div *ngIf="email?.errors?.['email']">Please enter a valid email address</div>
              </div>
            </div>

            <!-- Phone Number -->
            <div class="col-md-12 mb-5">
              <label class="form-label">Phone Number</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="phone_number"
                placeholder="Enter phone number"
              />
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
